import React from "react"
import { TypeColorNames } from "../../../theme/colors";
import { breakpointSize } from "../../../theme/mediaQuerie";

import Typography from "../../shared/typography/Typography";
import { DeleteButton } from "../DeleteButton";

import { Container, Header } from "./style";

interface IProps {
  children: React.ReactChild;
  onDelete: () => void;
  title: string;
  customBackground?: TypeColorNames;
  style?: React.CSSProperties;
}

const isMobile = window.innerWidth <= breakpointSize.Sm;

export const Card = ({children, onDelete, title, customBackground, style}: IProps) => {
  return(
    <Container background={customBackground} style={style}>
      <Header>
        <Typography type={ isMobile ? "labelS" : "labelL"} color="title">
          {title}
        </Typography>
        <DeleteButton onDelete={onDelete} />
      </Header>
      {children}
    </Container>
  );
}